import { useState } from 'react'
import { useEffectStart } from './useEffectStart'

export const useFetch = <T>(fetchFn?: () => Promise<T>, noFentOnStart?: boolean) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [data, setData] = useState<T>()

  const fetchData = () => {
    if (!fetchFn) {
      setLoading(false)
      return
    }
    setError('')
    setLoading(true)
    fetchFn()
      .then((result) => {
        setData(result)
      })
      .catch((error) => {
        setError(error.toString())
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffectStart(() => {
    if (!noFentOnStart) {
      fetchData()
    }
  })

  return { data, loading, error, fetchData }
}
